import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style, styleVariants, globalStyle } from '@vanilla-extract/css';
import { paragraph } from '../../markdown.css';
import { fillScope, layerHover, layerPressed, shiftHoverStroke } from '@customerio/pluma-components/css/utils';

export const messageContainerContent = style({}, 'message-container-content');

/* ——— Typography spacing inside messages ——— */

// Match both `p` and the markdown paragraph class: markdown paragraphs render
// as `<div>` to avoid hydration errors, while Pluma paragraph placeholders
// still render a `<p>`. The user bubble has zero vertical padding, so both
// rely on this margin for spacing.
globalStyle(`.${messageContainerContent} p, .${messageContainerContent} .${paragraph}`, {
  marginTop: themeVars.space['100'],
  marginBottom: themeVars.space['100'],
});

globalStyle(`.${messageContainerContent} li`, {
  marginTop: themeVars.space['050'],
  marginBottom: themeVars.space['050'],
});

globalStyle(`.${messageContainerContent} li > ul, .${messageContainerContent} li > ol`, {
  marginTop: themeVars.space['025'],
});

globalStyle(
  `.${messageContainerContent} h1, .${messageContainerContent} h2, .${messageContainerContent} h3, .${messageContainerContent} h4`,
  {
    marginTop: themeVars.space['200'],
    marginBottom: themeVars.space['075'],
  },
);

globalStyle(
  `.${messageContainerContent} h1:first-child, .${messageContainerContent} h2:first-child, .${messageContainerContent} h3:first-child, .${messageContainerContent} h4:first-child`,
  {
    marginTop: 0,
  },
);

export const messageContainerVariants = styleVariants(
  {
    user: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    model: {},
  },
  'message-container-variants',
);

export const messageContainerContentVariants = styleVariants(
  {
    user: {
      paddingTop: themeVars.space['0'],
      paddingBottom: themeVars.space['0'],
      paddingLeft: themeVars.space['150'],
      paddingRight: themeVars.space['150'],
      backgroundColor: fillScope('neutral', 'subtle'),
      color: themeVars.color['text-primary'],
      borderRadius: '18px',
      display: 'inline-flex',
      maxWidth: '80%',
      gap: themeVars.space['100'],
    },
    model: {
      display: 'flex',
      flexDirection: 'column',
      gap: themeVars.space['050'],
      lineHeight: 1.7,
    },
  },
  'message-container-content-variants',
);

globalStyle(`.${messageContainerContent}.${messageContainerContentVariants.model} > *:last-child`, {
  marginBottom: 0,
});

export const messageActionsContainer = style(
  {
    display: 'flex',
    alignItems: 'center',
    gap: themeVars.space['025'],
    opacity: 0,
    transition: 'opacity 0.2s ease',
    marginTop: 0,

    selectors: {
      [`${messageContainerContent}:hover &, &:focus-within`]: {
        opacity: 1,
      },
    },
  },
  'message-actions-container',
);

export const visibleMessageActionsContainer = style(
  {
    opacity: 1,
  },
  'visible-message-actions-container',
);

export const messageAction = style(
  {
    padding: themeVars.space['075'],
    borderRadius: themeVars.radius['4'],
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
    color: themeVars.color['mark-secondary'],

    ':hover': {
      backgroundColor: layerHover(),
      color: shiftHoverStroke(themeVars.color['mark-primary']),
    },

    ':active': {
      backgroundColor: layerPressed(),
      color: themeVars.color['mark-primary'],
    },
  },
  'message-action',
);

export const messageActionVariants = styleVariants(
  {
    default: {},
    active: {
      backgroundColor: fillScope('neutral', 'subtle'),
      color: themeVars.color['mark-primary'],
      cursor: 'default',

      ':hover': {
        backgroundColor: layerHover(fillScope('neutral', 'subtle')),
        color: shiftHoverStroke(themeVars.color['mark-primary']),
      },

      ':active': {
        backgroundColor: fillScope('neutral', 'subtle'),
        color: themeVars.color['mark-primary'],
        transform: 'none',
      },
    },
  },
  'message-action-variants',
);
